/**
 * Constantes para la landing de experiencia (CTA iMessage).
 * Un solo punto de verdad para teléfono, mensaje, CTA y precio inicial.
 */
export const LANDING_PHONE = '17866093374';
/** Precio inicial visible en hero (ej: "$499" o "From $499"). */
export const LANDING_STARTING_PRICE = 'From $499';
/** Texto único del CTA en toda la landing (estilo Hormozi, alta conversión). */
export const LANDING_CTA_TEXT = "I'M READY TO ENJOY";
/** Texto del CTA solo en la sección de reviews (What people are saying). */
export const LANDING_REVIEWS_CTA_TEXT = "BOOK NOW";
export const LANDING_IMESSAGE_PREDEFINED_MESSAGE =
  "Hi! 👋 I'd like to book a boating experience in Miami with Mr. Sea.\n\nI'd love to see what boats or yachts are available, pricing, and any promos you're offering. 🚤";

/**
 * Genera el enlace para abrir iMessage/SMS con mensaje predefinido.
 * En iOS abre iMessage cuando el destinatario tiene iPhone.
 */
export const getLandingIMessageHref = () => {
  const body = encodeURIComponent(LANDING_IMESSAGE_PREDEFINED_MESSAGE);
  return `sms:${LANDING_PHONE}&body=${body}`;
};
